import { login } from "@/api/api";
import {
  METIME_ADMIN_PROVIDER_URL,
  METIME_SUPER_ADMIN_PROVIDER_URL,
} from "@/const";

import { FORM_FIELD_NAMES } from "@/const/formFieldsTypes";

export const loginByTokens = ({
  accessToken,
  refreshToken,
  admin,
  redirect,
}) => {
  if (admin) {
    const redirectUrl = redirect || METIME_SUPER_ADMIN_PROVIDER_URL;
    window.location = `${redirectUrl}/authenticate?AUTH_TOKEN=${accessToken}`;
  } else {
    const redirectUrl = redirect || METIME_ADMIN_PROVIDER_URL;
    window.location = `${redirectUrl}?accessToken=${accessToken}&refreshToken=${refreshToken}`;
  }
};

export const loginByEmailAndPassword = async (email, pass, redirect) => {
  const { data } = await login(email, pass);
  if (data?.accessToken && data?.refreshToken) {
    if (redirect) {
      data.redirect = redirect;
    }
    loginByTokens(data);
  }
};

export const formFieldValidationHelper = (
  form,
  validationData,
  fieldName,
  fieldVlue,
  errors,
) => {
  const validation = validationData[fieldName]?.validation;
  if (!validation) {
    return;
  }
  errors[fieldName] = {};
  if (fieldName === FORM_FIELD_NAMES.CONFIRM_PASSWORD && fieldVlue) {
    if (form.password !== form.confirmPassword) {
      errors.confirmPassword = {};
      errors.confirmPassword.invalid =
        validationData.confirmPassword.validation.invalid.text;
    }
  } else if (validation.required && !fieldVlue) {
    errors[fieldName].required = validation.required.text;
  } else {
    Object.entries(validation).forEach(([validationKey, validationValue]) => {
      if (validationValue.regex) {
        if (!validationValue.regex.test(fieldVlue)) {
          errors[fieldName][validationKey] = validationValue.text;
        }
      }
    });
  }
};

export const isFormValidHelper = (errors) => {
  return (
    Object.values(errors).filter((value) => {
      return Object.values(value).length > 0;
    }).length === 0
  );
};
